import { render, staticRenderFns } from "./TaskDueNotificationTable.vue?vue&type=template&id=42528c14"
import script from "./TaskDueNotificationTable.vue?vue&type=script&lang=js"
export * from "./TaskDueNotificationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports